import type { Command, GameState } from "../domain/types/index.js";
import { bgmForState, syncGameBgm } from "./bgm/gameBgm.js";
import { playSoundForTransition } from "./gameSoundPlayer.js";

export function playTransitionAudio(previous: GameState, next: GameState, command: Command): void {
  void syncGameBgm(bgmForState(next));
  playSoundForTransition(previous, next, command);
}
